import currenciesData from 'currency-formatter/currencies.json';
import {Formik} from 'formik';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useTrackFont} from '../../containers/DataContainer/siteSettings/withTrackFont';
import {withoutSize} from '../../services/env/siteSettings/fonts/fonts';
import {validateNameYourPrice} from '../../services/utils/validateNameYourPrice/validateNameYourPrice';
import {Currency} from '../Currency/Currency';
import {Button} from '../ui/Button/Button';
import {TextInput} from '../ui/TextInput/TextInput';
import styles from './NameYourPriceForm.scss';

interface IProps {
  entityType: string;
  minPrice: number;
  maxPrice: number;
  currency: string;
  handleSubmit: ({price}: {price: number}) => void;
  handleValidationFailed: ({errorMessage, price}: {errorMessage: string; price: number}) => void;
}

export const NameYourPriceForm: React.FunctionComponent<IProps> = (props) => {
  const {minPrice, maxPrice, currency, entityType, handleSubmit, handleValidationFailed} = props;
  const {t} = useTranslation();
  const trackFont = useTrackFont();

  return (
    <Formik
      initialValues={{price: ''}}
      onSubmit={(values) => handleSubmit({price: values.price})}
      validate={validateNameYourPrice({
        t,
        minPrice,
        maxPrice,
        currency,
        entityType,
      })}
    >
      {({handleSubmit, values}) => (
        <form
          data-hook="nameYourPriceForm"
          onSubmit={(...args) => {
            const {price: errorMessage} = validateNameYourPrice({
              t,
              minPrice,
              maxPrice,
              currency,
              entityType,
            })(values);

            if (errorMessage) {
              handleValidationFailed({errorMessage, price: values.price});
            }
            return handleSubmit(...args);
          }}
          noValidate
        >
          <div className={styles.priceFieldWrapper}>
            <div className={styles.currency} style={withoutSize(trackFont)} data-hook="priceFieldCurrency">
              <Currency currency={currency}>{currenciesData[currency].symbol}</Currency>
            </div>
            <TextInput
              data-hook="priceField"
              name="price"
              type="number"
              min={minPrice}
              max={maxPrice}
              aria-label={t('mgw.nameYourPrice')}
              className={styles.nameYourPriceField}
            />
          </div>
          <Button type="submit" dataHook="continueButton" theme="big">
            {t('mgw.nameYourPriceContinue')}
          </Button>
        </form>
      )}
    </Formik>
  );
};
